import initializeGoogleAd from '@carwow/carwow_google_ads/app/javascript/initializer'

initializeGoogleAd()
